<template lang="pug">
  .store-feed(:class="{'new-item': false}")
    .store-feed-header
      .sync-logo
        img(:src="syncLogo" :class="{spinning: loading}")
      h3.header-title {{ storeInfo.pharmacyName }} {{ storeInfo.address1 }}{{ storeInfo.address2 ? ', ' : ''}}{{ storeInfo.address2 }}, {{ storeInfo.city }}, {{ storeInfo.stateCd }} {{ storeInfo.postalCode }} {{ storeInfo.phone }}
      button.btn.btn-primary(@click="$store.commit('stopStoreWatch', storeId)") Stop this Feed
    .store-feed-table
      Datatable(:column-count=" entries.length > 0 ? 6 : 1"
                :per-page="5"
                :footer="false"
                :entries="entries")
        template(v-if="entries.length > 0" slot="header")
          th.h6 Details
          th.h6 Date/Time
          th.h6 ActivityType
          th.h6 Transaction ID
          th.h6 Purchaser/Date of Birth
          th.h6 ID Info
        template(v-else slot="header")
          th.body-1.normal-font No transactions found since {{ $store.state.feedStarted.toLocaleString('en-US') }}
        template(slot-scope="props")
          tr(:class="{'new-item': animate}")
            td.body-2
              .td-wrapper
                a(href="" @click.prevent="$emit('showTransaction', props.entry.transactionSid)") View Details
            td.body-2
              .td-wrapper {{ props.entry.transactionDt }}
            td.body-2
              .td-wrapper {{ props.entry.transactionCd }}
            td.body-2
              .td-wrapper {{ props.entry.transactionSid }}
            td.body-2
              .td-wrapper
                div {{ props.entry.lastName }}, {{ props.entry.firstName }}
                div {{ props.entry.birthDt }}
            td.body-2
              .td-wrapper
                span(v-if="props.entry.idTypeCd") {{ props.entry.idTypeCd.split('_')[0] }}{{ props.entry.idTypeCd ? ': ' : ' ' }}
                span {{ props.entry.idNbr }}
                div(v-if="props.entry.idStateCd") Issuer: {{ props.entry.idStateCd }}
</template>

<script>
import Datatable from '@/components/Datatable'
import syncLogo from '@/assets/img/sync.svg'
import axios from '@/lib/axios'
import { globalError } from '@/lib/utils'

function getData(sid, since = false) {
  let args = since ? { sid, since } : { sid }
  return axios().get('/api/store_feed/transactions', { params: args })
}

function getStoreInfo(sid) {
  return axios().get('/api/misc/store_info', { params: { sid } })
}

export default {
  name: 'StoreFeedPanel',
  data: function() {
    return {
      syncLogo,
      loading: false,
      entries: [],
      timer: undefined,
      animate: false,
      storeInfo: {},
      since: null,
    }
  },
  props: {
    storeId: {
      type: [String, Number],
      default: '',
    },
  },
  methods: {
    reloadData: async function(firstLoad = false) {
      getStoreInfo(this.storeId)
        .then(resp => (this.storeInfo = resp.data))
        .catch(err => globalError(err))
      try {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 3000)
        let promise = firstLoad
          ? getData(this.storeId)
          : getData(this.storeId, this.since)
        let transaction = (await promise).data
        if (!transaction || transaction.length < 1) {
          // If we don't get any transactions, rerun the transaction query one more without since,
          // to pull the most recent transaction
          if (!firstLoad) {
            transaction = (await getData(this.storeId)).data
            if (transaction && transaction.length > 1 && transaction[0]) {
              this.since = transaction[0].epochTs
            }
          }
          this.entries = transaction
          return
        }
        if (
          firstLoad &&
          transaction &&
          transaction.length > 0 &&
          transaction[0]
        )
          this.since = transaction[0].epochTs

        // If the most recent new transaction has the same ID as the most recent old transaction, then
        // there haven't been any new ones, so we can skip the animation.
        let transactionSids = this.entries.map(t => t.transactionSid)
        let newTrxSids = transaction.map(t => t.transactionSid)
        let trxChanged = transactionSids[0] !== newTrxSids[0]
        if (!trxChanged) {
          this.entries = transaction
          return
        }

        this.animate = true
        this.entries = transaction
        setTimeout(() => {
          this.animate = false
        }, 1000)
        if (trxChanged && newTrxSids.length >= transactionSids.length)
          this.$emit('newData')
      } catch (err) {
        globalError(err)
      }
    },
  },
  mounted: function() {
    this.reloadData(true)
    this.interval = setInterval(() => this.reloadData(), 5000)
  },
  beforeDestroy: function() {
    clearInterval(this.interval)
  },
  components: {
    Datatable,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/custom';

.store-feed-header {
  border: 1px solid #e6e6e6;
  padding: 1rem;
  display: flex;
  align-items: center;
}

.sync-logo {
  flex-grow: 1;
  img {
    height: 2rem;
  }
}
.spinning {
  animation: spin 3s linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.header-title {
  flex-grow: 30;
}

.normal-font {
  font-weight: normal;
}

.new-item:first-child {
  z-index: 0;
  animation-duration: 1.5s;
  animation-name: box-slide;

  a {
    animation-duration: 1.5s;
    animation-name: link-slide;
  }

  .td-wrapper {
    animation-duration: 1.5s;
    animation-name: height-slide;
  }
}

@keyframes height-slide {
  0% {
    max-height: 0;
    padding: 0;
  }

  30% {
    max-height: 0;
    padding: 0;
  }

  100% {
    max-height: 5rem;
    padding: auto;
  }
}

@keyframes box-slide {
  0% {
    color: rgba(#212529, 0);
  }

  30% {
    color: rgba(#212529, 0);
  }

  100% {
    color: #212529;
  }
}

@keyframes link-slide {
  0% {
    opacity: 0;
  }

  30% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
